export default {
  createSuccess: "Vertriebsagent erfolgreich erstellt!",
  scopeAssigned: "Zuweisung gespeichert",
  scopeRemoved: "Zuweisung entfernt",
  removeScopeError: "Zuweisung konnte nicht entfernt werden",
  create: {
    title: "Vertriebsagent erstellen",
    namePlaceholder: "Anzeigename",
    emailPlaceholder: "agent@beispiel.de",
    submit: "Erstellen",
  },
  detail: {
    invalidRoute: "Ungültige Route.",
    roleLabel: "Vertriebsagent",
    statAssociations: "Zugeordnete Benutzer",
    loadDetail: "Vertriebsagentendetails werden geladen...",
    loadError: "Vertriebsagent konnte nicht geladen werden",
    toastStatusUpdated: "Vertriebsagentenstatus aktualisiert",
    toastStatusError: "Vertriebsagentenstatus konnte nicht aktualisiert werden",
    scopedHelp:
      "Weisen Sie diesen Agenten bestimmten Aktivitäten oder Strukturen mit einem Provisionssatz zu.",
    activitySection: "Aktivitäten",
    houseSection: "Strukturen",
    addActivity: "Aktivität zuweisen",
    addHouse: "Struktur zuweisen",
    colActivity: "Aktivität",
    colHouse: "Struktur",
    colOwner: "Eigentümer",
    colHost: "Gastgeber",
    colSaRate: "Vertriebsagenten-Satz",
    emptyActivities: "Noch keine Aktivitätszuweisungen.",
    emptyHouses: "Noch keine Strukturzuweisungen.",
    remove: "Entfernen",
    removeConfirmActivity:
      "Vertriebsagenten-Zuweisung für diese Aktivität entfernen?",
    removeConfirmHouse:
      "Vertriebsagenten-Zuweisung für diese Struktur entfernen?",
    modalActivityTitle: "Aktivität zuweisen",
    modalActivitySubtitle:
      "Wählen Sie eine Aktivität und legen Sie die Provision fest, die dieser Agent auf Buchungen dieser Aktivität erhält.",
    modalHouseTitle: "Struktur zuweisen",
    modalHouseSubtitle:
      "Wählen Sie eine Struktur und legen Sie die Provision fest, die dieser Agent auf Buchungen dieser Struktur erhält.",
    selectActivityStep: "Aktivität auswählen",
    selectStructureStep: "Struktur auswählen",
    searchActivitiesPlaceholder: "Nach Aktivitäts- oder Eigentümername suchen…",
    searchStructuresPlaceholder: "Nach Struktur- oder Eigentümername suchen…",
    noActivitiesFound: "Keine Aktivitäten gefunden.",
    noStructuresFound: "Keine Strukturen gefunden.",
    saCommissionPercentLabel: "Vertriebsagenten-Provision (%)",
    invalidCommission: "Geben Sie einen gültigen Prozentsatz ein.",
  },
  associations: {
    title: "Ihre Zuweisungen",
    description:
      "Jede Zeile ist eine Aktivität oder Struktur, der Sie zugewiesen sind, mit Ihrem Provisionssatz",
    loading: "Zuweisungen werden geladen...",
    errorLoad: "Zuweisungen konnten nicht geladen werden",
    colName: "Aktivität / Struktur",
    colOwner: "Eigentümer",
    colRate: "Ihr Satz",
    scopeActivity: "Aktivität",
    scopeHouse: "Struktur",
    statActivities: "Aktivitäten",
    statHouses: "Strukturen",
    statTopRate: "Höchster Satz",
    empty:
      "Noch keine Zuweisungen. Kontaktieren Sie Staff, um Ihr Konto mit Aktivitäten oder Strukturen zu verknüpfen.",
  },
} as const;
